import React from 'react';
import PropTypes from 'prop-types';

const Picture = (props) => {
  return <>
    <picture>
      <source type="image/png" srcSet={props.image}/>
      <img src={props.image}
           className="card-img"
           alt={props.title}
           title={props.title}/>
    </picture>
  </>
}

Picture.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Picture;